<div mat-dialog-title fxLayoutAlign="center center"></div>
<mat-dialog-content>
  <p>
    These other procedures share the same CPT code. Select any you'd like to
    add.
  </p>

  <mat-selection-list #list [(ngModel)]="selectedProducts">
    <mat-list-option
      *ngFor="let product of products"
      [value]="product"
      selected
    >
      {{ product.name }}
    </mat-list-option>
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-button (click)="toggleSelectAll()">{{ selectAllLabel }}</button>
  <button
    mat-raised-button
    (click)="dialogRef.close(selectedProducts)"
    color="primary"
  >
    Add selected
  </button>
</mat-dialog-actions>
